module.exports = __webpack_public_path__ + "media/promo/velle/images/article-83dc091f7c8a6554337f1d0de907453f.jpg";